// extracted by mini-css-extract-plugin
export default {"textArea":"TextArea_textArea__h8J6T","isError":"TextArea_isError__bG85I","disabled":"TextArea_disabled__qjq5e"};